module.exports = {
	"id": "GE",
	"name": "Georgia",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.016126,
			"5": 0.016126,
			"6": 0.008063,
			"7": null,
			"8": 0.016126,
			"9": 0.016126,
			"10": 0.016126,
			"11": 0.032252,
			"12": 0.048378,
			"13": 0.016126,
			"14": 0.008063,
			"15": 0.032252,
			"16": 0.016126,
			"17": 0.040315,
			"18": 0.032252,
			"19": 0.032252,
			"20": 0.024189,
			"21": 0.048378,
			"22": 0.072567,
			"23": 0.064504,
			"24": 0.048378,
			"25": 0.032252,
			"26": 0.040315,
			"27": 0.056441,
			"28": 0.032252,
			"29": 0.016126,
			"30": 0.064504,
			"31": 0.08063,
			"32": 0.008063,
			"33": 0.096756,
			"34": 0.016126,
			"35": 0.032252,
			"36": 0.032252,
			"37": 0.024189,
			"38": 0.040315,
			"39": 0.153197,
			"40": 0.056441,
			"41": 0.072567,
			"42": 0.040315,
			"43": 0.306394,
			"44": 0.120945,
			"45": 0.096756,
			"46": 0.088693,
			"47": 0.193512,
			"48": 0.137071,
			"49": 2.959121,
			"50": 0.193512,
			"51": 0.935308,
			"52": 0.64504,
			"53": 38.242809,
			"54": 11.868736,
			"55": 0.306394,
			"56": 0.056441,
			"57": null
		},
		"firefox": {
			"2": 0.008063,
			"3": 0.040315,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.016126,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.008063,
			"21": 0.016126,
			"22": null,
			"23": null,
			"24": 0.008063,
			"25": 0.024189,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.016126,
			"32": null,
			"33": 0.016126,
			"34": null,
			"35": 0.032252,
			"36": 0.016126,
			"37": 0.024189,
			"38": 0.024189,
			"39": 0.016126,
			"40": 0.008063,
			"41": 0.008063,
			"42": 0.008063,
			"43": 0.08063,
			"44": 0.032252,
			"45": 0.056441,
			"46": 0.056441,
			"47": 0.346709,
			"48": 0.169323,
			"49": 2.555971,
			"50": 0.040315,
			"51": null,
			"52": null,
			"3.5": 0.056441,
			"3.6": 0.16126
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.096756,
			"15": 0.040315,
			"16": 0.048378,
			"17": 0.032252,
			"18": 0.056441,
			"19": 0.024189,
			"20": 0.048378,
			"21": 0.008063,
			"22": 0.008063,
			"23": null,
			"24": 0.016126,
			"25": 0.016126,
			"26": 0.016126,
			"27": 0.040315,
			"28": 0.024189,
			"29": 0.024189,
			"30": 0.040315,
			"31": 0.016126,
			"32": 0.040315,
			"33": 0.048378,
			"34": 0.08063,
			"35": 0.08063,
			"36": 0.395087,
			"37": 0.137071,
			"38": 0.177386,
			"39": 0.177386,
			"40": 6.974495,
			"41": 1.233639,
			"42": 0.024189,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0.008063,
			"10.5": 0.008063,
			"10.6": 0.024189,
			"11.1": 0.008063,
			"11.5": 0.024189,
			"11.6": 0.056441,
			"12.1": 0.580536
		},
		"safari": {
			"0": null,
			"4": 0.032252,
			"5": 0.048378,
			"6": null,
			"7": null,
			"8": 0.032252,
			"9": 0.040315,
			"10": 0.266079,
			"3.1": null,
			"3.2": null,
			"5.1": 0.056441,
			"6.1": 0.016126,
			"7.1": null,
			"9.1": 0.153197
		},
		"ios_saf": {
			"8": 0,
			"10": 2.26823022565,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0611261799542,
			"8.1-8.4": 0.112928027373,
			"9.0-9.2": 0.0538739213156,
			"9.3": 0.821922645712
		},
		"android": {
			"3": 0,
			"4": 0.0225282609819,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00281603262274,
			"4.1": 0.0812626556848,
			"4.2-4.3": 0.203156639212,
			"4.4": 0.465852253876,
			"4.4.3-4.4.4": 0.469875157623
		},
		"ie": {
			"6": null,
			"7": 0.00822982068966,
			"8": 0.304503365517,
			"9": 0.139906951724,
			"10": 0.0905280275862,
			"11": 1.84347983448,
			"5.5": null
		},
		"op_mob": {
			"0": 0.120890482655,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00335806896265
		},
		"edge": {
			"12": 0.032252,
			"13": 0.903056,
			"14": 0.596662
		},
		"ie_mob": {
			"10": 0.0721873521127,
			"11": 0.293905647887
		},
		"bb": {
			"7": 0.01210625,
			"10": null
		},
		"samsung": {
			"0": 1.284231
		},
		"and_uc": {
			"0": 0.501683
		},
		"op_mini": {
			"0": 1.62873644838
		},
		"and_chr": {
			"0": 11.606415
		},
		"and_ff": {
			"0": 0.007748
		}
	},
	"total": 96.79008925
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/GE.json
 ** module id = 527
 ** module chunks = 0
 **/